//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import _ from "lodash";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Risk_ItemVideo from "./Risk_ItemVideo";
import { postureModal} from "../assets/lang.conf/root";
export default {
  name: "Posture_modal",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      ...postureModal
    }
  },
  directive: {
    bModalDirective
  },
  components: {
    Risk_ItemVideo
  },
  props: ["modalInfo", "isUpdate"],
  data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      pauseVideo: false,
      lang: this.$i18n.locale == "cn" ? true : false
    };
  },
  computed: {},
  methods: {
    getRiskImg(risk) {
      let direction = "normal";
      let img;
      console.log(risk.key);
      if (
        !_.isNull(risk.direction) &&
        risk.key !== "legO" &&
        risk.key !== "legX" &&
        risk.key !== "legXO" &&
        risk.key !== "kneeOverstretch"
      ) {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    show() {},
    changeIsPause: function() {
      this.pauseVideo = false;
      console.log("pauseVideo;", this.pauseVideo);
    },
    hideModal() {
      this.pauseVideo = true;
      this.$emit("hideModal");
    },
    initRiskBar() {
      this.$emit("initRiskBar");
    },
    getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: this.$t("normal"),
            className: "level-normal"
          };
        case this.level.mild:
          return {
            des: this.$t("potentialRisk"),
            className: "level-mild"
          };
        case this.level.severe:
          return {
            des: this.$t("highRisk"),
            className: "level-severe"
          };
      }
    }
  },
  created() {
    console.log("model createds:", this.modalInfo);
  }
};



// WEBPACK FOOTER //
// ./src/components/Posture_modal.vue